import { useRef, useState } from 'react';
import { api } from '../api/client.js';

interface Props {
  onAdded: () => void;
}

// Capture is sacred: one field, one action. Enter (or the button) saves a draft
// and immediately clears, keeping focus for the next capture. Nothing else is
// required.
export function QuickAdd({ onAdded }: Props) {
  const [title, setTitle] = useState('');
  const [busy, setBusy] = useState(false);
  const [flash, setFlash] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  async function submit() {
    const value = title.trim();
    if (!value || busy) return;
    setBusy(true);
    try {
      await api.createEntry({ title: value });
      setTitle('');
      setFlash('Saved as draft');
      onAdded();
      inputRef.current?.focus();
      setTimeout(() => setFlash(null), 1500);
    } catch (err) {
      setFlash(err instanceof Error ? err.message : 'Failed to save');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form
      className="quick-add"
      onSubmit={(e) => {
        e.preventDefault();
        void submit();
      }}
    >
      <input
        ref={inputRef}
        type="text"
        className="quick-add-input"
        placeholder="Log an accomplishment… (title only — enrich later)"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        autoFocus
        aria-label="Quick add entry title"
      />
      <button type="submit" disabled={busy || title.trim() === ''}>
        {busy ? 'Adding…' : 'Add'}
      </button>
      {flash && <span className="quick-add-flash">{flash}</span>}
    </form>
  );
}
